import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2e962a57"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  class: "title"
}, "日志信息", -1));
const _hoisted_2 = {
  style: {
    "max-width": "400px",
    "overflow": "hidden",
    "text-overflow": "ellipsis",
    "white-space": "nowrap"
  }
};
import { getLogDetail } from '@/api/sys';
import { ref, onMounted } from 'vue';
import { useRoute } from 'vue-router';
export default {
  __name: 'info',
  setup(__props) {
    const route = useRoute();
    const {
      id
    } = route.params;
    // loading效果
    const loading = ref(false);
    const logInfo = ref({});
    const getData = async () => {
      loading.value = true;
      const res = await getLogDetail(id);
      logInfo.value = res;
      loading.value = false;
    };
    onMounted(() => {
      getData();
    });
    return (_ctx, _cache) => {
      const _component_el_descriptions_item = _resolveComponent("el-descriptions-item");
      const _component_el_tooltip = _resolveComponent("el-tooltip");
      const _component_el_descriptions = _resolveComponent("el-descriptions");
      const _component_el_card = _resolveComponent("el-card");
      const _directive_loading = _resolveDirective("loading");
      return _withDirectives((_openBlock(), _createBlock(_component_el_card, {
        shadow: "never",
        class: "container"
      }, {
        default: _withCtx(() => [_hoisted_1, _createVNode(_component_el_descriptions, {
          border: "",
          class: "descriptionsContent"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_descriptions_item, {
            span: 1,
            label: "操作人"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(logInfo.value.creatorId), 1)]),
            _: 1
          }), _createVNode(_component_el_descriptions_item, {
            span: 1,
            label: "操作时间"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(logInfo.value.createTime), 1)]),
            _: 1
          }), _createVNode(_component_el_descriptions_item, {
            span: 1,
            label: "标题"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(logInfo.value.title), 1)]),
            _: 1
          }), _createVNode(_component_el_descriptions_item, {
            span: 1,
            label: "ip地址"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(logInfo.value.remoteAddr), 1)]),
            _: 1
          }), _createVNode(_component_el_descriptions_item, {
            span: 1,
            label: "请求URI"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(logInfo.value.requestUri), 1)]),
            _: 1
          }), _createVNode(_component_el_descriptions_item, {
            span: 1,
            label: "操作方式"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(logInfo.value.method), 1)]),
            _: 1
          }), _createVNode(_component_el_descriptions_item, {
            span: 3,
            label: "执行时间"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(logInfo.value.time), 1)]),
            _: 1
          }), _createVNode(_component_el_descriptions_item, {
            span: 3,
            label: "备注信息"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(logInfo.value.remark), 1)]),
            _: 1
          }), _createVNode(_component_el_descriptions_item, {
            span: 3,
            label: "操作提交的参数"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_tooltip, {
              class: "box-item",
              effect: "dark",
              content: logInfo.value.params,
              placement: "bottom"
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_2, _toDisplayString(logInfo.value.params), 1)]),
              _: 1
            }, 8, ["content"])]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      })), [[_directive_loading, loading.value]]);
    };
  }
};